let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fX2zx")).then(() => parcelRequire('8R1NN'));